import barba from '@barba/core'


/**
 * Track if user if printing 
 */
let isPrint = false
window.addEventListener("beforeprint", e => isPrint = true)
window.addEventListener("afterprint", e => isPrint = false)



/**
 * Retreive the state from history on (if available)
 */
function GetPageStateFromHistory() {
    if (window.history.state && window.history.state.pageState) {
        return { ...window.history.state.pageState }
    }
    return {}
}



/**
 * Retreive the state from history on initial page load (if available).
 * This MUST be done before Barba.JS init.
 */
let pageState = GetPageStateFromHistory()



/**
 * User navigate trough history, snatch the "state" before
 * Barba.JS. To acheive this, this eventListener must be set
 * before Barba.JS init.
 */
window.addEventListener('popstate', e => {
    pageState = GetPageStateFromHistory()
});



/**
 * Barba is ready (init), write state to history.
 */
barba.hooks.ready(() => {
    WritePageStateToHistory()
})




/**
 * After transition, write state to history.
 */
barba.hooks.after(() => {
    WritePageStateToHistory()
})



/**
 * Barba is transitionning to a page.
 * - Create new page state if new page from Barba.JS
 * - Write to the history current state.
 */
barba.hooks.page(({ trigger }) => {
    if (trigger === 'barba' || typeof trigger === 'object') {
        pageState = {}
    }
    WritePageStateToHistory()
})



/**
 * Write current page state to current history
 */
let writeTimeout = null
function WritePageStateToHistory() {
    if (isPrint) {
        return
    }
    const write = () => {
        let state = window.history.state
        if (!state || !pageState) {
            return
        }
        state.pageState = pageState
        window.history.replaceState(state, '')
    }
    clearTimeout(writeTimeout)
    writeTimeout = setTimeout(write, 0)
    
}



/**
 * Static method to get() and set() property to the state
 */
class PageState {
    static set(prop, val) {
        pageState[prop] = JSON.stringify(val)
        WritePageStateToHistory()
    }
    static get(prop) {
        WritePageStateToHistory()
        if (pageState.hasOwnProperty(prop)) {
            return JSON.parse(pageState[prop])
        }
        return null
    }
    static empty() {
        pageState = {}
        WritePageStateToHistory()
    }
}



export { PageState }
export default PageState
